/**
 * Tone guard for AI-rephrased notifications.
 *
 * The witty-sidekick rephrase is fun when it lands and grating when it does not
 * ("where's my medal?" on a save toast, in a Kaiser-branded program). The model gets the
 * rules in its prompt; this is the deterministic backstop: anything that fails falls back
 * to the plain system copy, which is always correct.
 */

const BANNED =
  /\b(refund|money|pay(?:ment)?|fail(?:ed|ure)?|lol|ugh|finally|wrong|medal|whatever|meh)\b/i;
const EMOJI = /\p{Extended_Pictographic}/gu;
const SHOUTING = /\b[A-Z]{4,}\b/;

export const TONE_RULES = [
  'Never be sarcastic about the student or their pace',
  'Never mention money, prices, payments or refunds',
  'No ALL-CAPS words, at most one emoji, plain grade-8 English',
  'Use the first name at most once, never a nickname'
];

export function passesToneGuard(text: string, maxWords = 15): boolean {
  const t = (text || '').trim();
  if (!t) return false;
  if (t.split(/\s+/).length > maxWords) return false;
  if ((t.match(EMOJI) || []).length > 1) return false;
  if (BANNED.test(t)) return false;
  if (SHOUTING.test(t)) return false;
  return true;
}
